export default __webpack_public_path__ + "static/media/ic-notification-white.830f9279.svg";